module.exports = __webpack_public_path__ + "media/src/images/partners/itmo-4f8e6279174783a14e0b1aa20d64eb54.png";